import React from 'react';
import { SiteHeader } from './components/SiteHeader';
import { SiteFooter } from './components/SiteFooter';
import { Article } from './pages/Article';
export function App() {
  return <div className="flex min-h-screen w-full flex-col bg-paper text-ink" data-id="element-0" data-mp="3k9b0pqx7f3wg">
      <SiteHeader data-id="element-1" data-mp="3k78elhz69ux0" />
      <div className="flex-1" data-id="element-2" data-mp="3faredpep7q3k">
        <Article data-id="element-3" data-mp="3fbjd393le3y2" />
      </div>
      <SiteFooter data-id="element-4" data-mp="3fb9i173ox6li" />
    </div>;
}